import _sfc_main from "./component-library128.mjs";
import "./component-library129.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "badge", class: _setup.containerClasses, style: _setup.styles }, [_c("div", { staticClass: "badge__content" }, [_vm._t("default", function() {
    return [_vm.text ? _c("span", { domProps: { "innerHTML": _vm._s(_vm.text) } }) : _vm._e()];
  })], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8668f90c",
  null,
  null
);
const Badge = __component__.exports;
export {
  Badge as default
};
